// src/pages/manager/LoungeDiscountManager.jsx
import React from 'react';
import OrderDiscountManager from '../DiscountComplimentaryManager';

const LoungeDiscountManager = () => {
  return <OrderDiscountManager locationKey="lounge" />;
};

export default LoungeDiscountManager;